import React from "react";

import "./PrivacyPolicyContent.css";

const PrivacyPolicy = () => {
  return (
    <>
      <div className="termsContainer">
        <h2>POLITIKA PRIVATNOSTI</h2>

        <div className="termsContent">
          <p>
            <strong>Datum posljednje izmjene:</strong> 11.08.2026.
          </p>

          <section>
            <h3>1. Voditelj obrade ličnih podataka</h3>

            <p>
              Ova Politika privatnosti odnosi se na korištenje internetske
              prodavnice Optika Alpha Focus, dostupne na adresi{" "}
              <a
                href="https://optika-alphafocus.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                optika-alphafocus.com
              </a>
              .
            </p>

            <p>Voditelj obrade ličnih podataka je:</p>

            <p>
              <strong>
                TR ALPHA FOCUS, vl. Selimović Vedad, Srebrenik
              </strong>
              <br />
              Ulica 1. Marta
              <br />
              75350 Srebrenik
              <br />
              Bosna i Hercegovina
              <br />
              ID broj: 4311663900005
              <br />
              Telefon:{" "}
              <a href="tel:+387603317696">+387 60 331 7696</a>
              <br />
              E-mail:{" "}
              <a href="mailto:optika.alpha@gmail.com">
                optika.alpha@gmail.com
              </a>
            </p>

            <p>
              Adresa sjedišta i prodajnog mjesta je ista. U nastavku teksta
              koristimo izraze „Trgovac“, „mi“ ili „Optika Alpha Focus“.
            </p>
          </section>

          <section>
            <h3>2. Koje lične podatke prikupljamo</h3>

            <p>
              Prikupljamo samo podatke potrebne za pružanje naših usluga,
              obradu narudžbi i ispunjavanje zakonskih obaveza.
            </p>

            <p>Prilikom naručivanja možemo prikupljati:</p>

            <ul>
              <li>ime i prezime;</li>
              <li>adresu za dostavu i naplatu;</li>
              <li>grad, poštanski broj i državu;</li>
              <li>broj telefona;</li>
              <li>e-mail adresu;</li>
              <li>podatke o naručenim proizvodima;</li>
              <li>odabrani način plaćanja;</li>
              <li>iznos, broj i status narudžbe;</li>
              <li>podatke potrebne za dostavu, reklamaciju ili povrat;</li>
              <li>komunikaciju koju nam kupac pošalje;</li>
              <li>
                tehničke podatke, kao što su IP adresa, vrsta uređaja,
                internetski preglednik i podaci o korištenju stranice, kada su
                potrebni radi sigurnosti i funkcioniranja webshopa.
              </li>
            </ul>

            <p>
              Ne prikupljamo niti pohranjujemo puni broj platne kartice, datum
              isteka kartice ili CVV sigurnosni broj.
            </p>
          </section>

          <section>
            <h3>3. Svrhe obrade podataka</h3>

            <p>Lične podatke obrađujemo radi:</p>

            <ul>
              <li>primanja, obrade i isporuke narudžbi;</li>
              <li>potvrđivanja identiteta i kontaktiranja kupca;</li>
              <li>obrade plaćanja i praćenja statusa transakcije;</li>
              <li>izdavanja računa i vođenja poslovnih evidencija;</li>
              <li>rješavanja reklamacija, povrata i zahtjeva kupaca;</li>
              <li>sprečavanja prevara i zloupotrebe webshopa;</li>
              <li>
                održavanja sigurnosti i tehničke funkcionalnosti stranice;
              </li>
              <li>
                ispunjavanja zakonskih, poreskih, računovodstvenih i drugih
                obaveza;
              </li>
              <li>
                slanja promotivnih obavijesti isključivo kada je korisnik dao
                posebnu saglasnost.
              </li>
            </ul>

            <p>
              Kupovina nije uslovljena davanjem saglasnosti za primanje
              marketinških poruka.
            </p>
          </section>

          <section>
            <h3>4. Kartično plaćanje i sigurnost</h3>

            <p>
              Kartično plaćanje obrađuje Monri Payments putem sistema Monri
              WebPay. Podaci o kartici unose se u sigurnom Monri okruženju i
              nisu dostupni Trgovcu.
            </p>

            <p>
              Komunikacija tokom plaćanja zaštićena je TLS/SSL enkripcijom.
              Monri Payments je pružalac platnih usluga certificiran prema PCI
              DSS Level 1 standardu. Za dodatnu potvrdu identiteta kupca može
              se koristiti 3D Secure sigurnosni postupak banke koja je izdala
              karticu.
            </p>

            <p>
              Trgovac ne pohranjuje puni broj kartice, datum isteka niti CVV
              kod. Možemo pohraniti samo podatke o rezultatu transakcije, kao
              što su broj narudžbe, iznos, valuta, status plaćanja i
              identifikator transakcije.
            </p>

            <p>
              Više informacija dostupno je na{" "}
              <a
                href="https://monri.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                službenoj stranici Monri Payments
              </a>
              .
            </p>
          </section>

          <section>
            <h3>5. Pravna osnova obrade</h3>

            <p>Lične podatke obrađujemo kada je obrada potrebna:</p>

            <ul>
              <li>za zaključivanje i izvršavanje ugovora o kupovini;</li>
              <li>radi ispunjavanja zakonskih obaveza Trgovca;</li>
              <li>
                radi legitimnog interesa, kao što su sigurnost webshopa,
                sprečavanje prevara i zaštita pravnih zahtjeva;
              </li>
              <li>
                na osnovu saglasnosti korisnika, posebno za marketing i
                opcionalne kolačiće.
              </li>
            </ul>

            <p>
              Korisnik može povući saglasnost u bilo kojem trenutku, bez
              uticaja na zakonitost obrade izvršene prije njenog povlačenja.
            </p>
          </section>

          <section>
            <h3>6. Primaoci ličnih podataka</h3>

            <p>
              Podaci mogu biti dostupni samo osobama i poslovnim partnerima
              kojima su potrebni za izvršavanje odgovarajućeg posla,
              uključujući:
            </p>

            <ul>
              <li>
                Monri Payments i banke uključene u obradu kartičnog plaćanja;
              </li>
              <li>dostavne i kurirske službe;</li>
              <li>
                pružaoce hostinga, održavanja i informatičke podrške;
              </li>
              <li>računovodstvene, pravne i druge stručne saradnike;</li>
              <li>
                nadležna tijela kada je dostavljanje podataka propisano
                zakonom.
              </li>
            </ul>

            <p>
              Od poslovnih partnera zahtijevamo odgovarajuću zaštitu ličnih
              podataka i korištenje podataka isključivo za ugovorenu ili
              zakonom određenu svrhu.
            </p>

            <p>Lične podatke kupaca ne prodajemo trećim stranama.</p>
          </section>

          <section>
            <h3>7. Marketing</h3>

            <p>
              Promotivne poruke šaljemo samo osobama koje su za to dale jasnu,
              posebnu i dobrovoljnu saglasnost.
            </p>

            <p>
              Saglasnost za marketing može se povući u bilo kojem trenutku
              putem poveznice za odjavu u promotivnoj poruci ili slanjem
              zahtjeva na{" "}
              <a href="mailto:optika.alpha@gmail.com">
                optika.alpha@gmail.com
              </a>
              .
            </p>

            <p>
              Povlačenje saglasnosti ne utiče na obradu podataka potrebnu za
              ranije izvršenu kupovinu, račun, dostavu, reklamaciju ili drugu
              zakonsku obavezu.
            </p>
          </section>

          <section>
            <h3>8. Rok čuvanja podataka</h3>

            <p>
              Lične podatke čuvamo samo onoliko dugo koliko je potrebno za
              svrhu za koju su prikupljeni ili koliko zahtijevaju primjenjivi
              računovodstveni, poreski, potrošački i drugi propisi.
            </p>

            <p>
              Podaci povezani s narudžbama, plaćanjima i računima čuvaju se u
              zakonom propisanom roku. Podaci koji se obrađuju isključivo na
              osnovu saglasnosti čuvaju se do njenog povlačenja, osim ako
              postoji druga pravna osnova za njihovo dalje čuvanje.
            </p>
          </section>

          <section>
            <h3>9. Prava korisnika</h3>

            <p>
              U skladu s primjenjivim propisima o zaštiti ličnih podataka,
              korisnik može zatražiti:
            </p>

            <ul>
              <li>informacije o obradi svojih ličnih podataka;</li>
              <li>pristup svojim podacima;</li>
              <li>ispravku netačnih ili nepotpunih podataka;</li>
              <li>
                brisanje podataka kada više ne postoji pravna osnova za
                njihovo čuvanje;
              </li>
              <li>ograničenje obrade;</li>
              <li>podnošenje prigovora na određenu obradu;</li>
              <li>povlačenje prethodno date saglasnosti;</li>
              <li>prenosivost podataka, kada je primjenjiva.</li>
            </ul>

            <p>
              Zahtjev se može poslati na{" "}
              <a href="mailto:optika.alpha@gmail.com">
                optika.alpha@gmail.com
              </a>
              . Radi zaštite korisnika možemo zatražiti razumnu potvrdu
              identiteta prije postupanja po zahtjevu.
            </p>

            <p>
              Korisnik također može podnijeti prigovor Agenciji za zaštitu
              ličnih podataka u Bosni i Hercegovini ili drugom nadležnom
              tijelu.
            </p>
          </section>

          <section>
            <h3>10. Zaštita podataka</h3>

            <p>
              Primjenjujemo odgovarajuće tehničke i organizacijske mjere radi
              zaštite ličnih podataka od neovlaštenog pristupa, gubitka,
              izmjene, objavljivanja ili zloupotrebe.
            </p>

            <p>
              Pristup podacima imaju samo zaposlenici i saradnici kojima su
              podaci potrebni za obavljanje njihovih poslova i koji su
              obavezani na povjerljivost.
            </p>

            <p>
              Iako poduzimamo razumne mjere zaštite, nijedan način prijenosa
              ili pohranjivanja podataka putem interneta ne može garantovati
              apsolutnu sigurnost.
            </p>
          </section>

          <section>
            <h3>11. Kolačići</h3>

            <p>
              Webshop može koristiti neophodne kolačiće za rad korpe,
              sigurnost, održavanje korisničke sesije i osnovne funkcije
              stranice.
            </p>

            <p>
              Analitički i marketinški kolačići koriste se samo u skladu s
              primjenjivim pravilima i, kada je potrebno, nakon prethodne
              saglasnosti korisnika.
            </p>
          </section>

          <section>
            <h3>12. Podaci maloljetnih osoba</h3>

            <p>
              Webshop nije namijenjen samostalnom sklapanju ugovora od strane
              osoba koje prema primjenjivom zakonu nemaju potrebnu poslovnu
              sposobnost. Takve osobe trebaju koristiti webshop uz saglasnost
              roditelja ili zakonskog staratelja.
            </p>
          </section>

          <section>
            <h3>13. Poveznice prema drugim stranicama</h3>

            <p>
              Webshop može sadržavati poveznice prema stranicama drugih
              pravnih subjekata. Ne odgovaramo za njihove politike privatnosti
              i preporučujemo korisnicima da ih pročitaju prije dostavljanja
              ličnih podataka.
            </p>
          </section>

          <section>
            <h3>14. Izmjene Politike privatnosti</h3>

            <p>
              Ovu Politiku privatnosti možemo povremeno izmijeniti zbog
              promjena u poslovanju, tehnologiji ili primjenjivim propisima.
              Važeća verzija uvijek će biti objavljena na ovoj stranici s
              naznačenim datumom posljednje izmjene.
            </p>
          </section>

          <section>
            <h3>15. Kontakt</h3>

            <p>
              Za pitanja, zahtjeve ili prigovore u vezi s privatnošću i
              obradom ličnih podataka možete nas kontaktirati:
            </p>

            <p>
              <strong>
                TR ALPHA FOCUS, vl. Selimović Vedad, Srebrenik
              </strong>
              <br />
              Ulica 1. Marta
              <br />
              75350 Srebrenik
              <br />
              Bosna i Hercegovina
              <br />
              Telefon:{" "}
              <a href="tel:+387603317696">+387 60 331 7696</a>
              <br />
              E-mail:{" "}
              <a href="mailto:optika.alpha@gmail.com">
                optika.alpha@gmail.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;